// Pass 6.3.6 — persistent "back to home" affordance for inner pages
// (/browse, /status, /status/:teamId, /users). Icon-only, top-left,
// mirroring SignOutButton on the right. NOT rendered on /chooser
// (you're already home).

import { Home } from "lucide-react";
import { Link } from "react-router-dom";

import { Tooltip } from "./ui/Tooltip";

export function HomeButton() {
  return (
    <Tooltip content="Back to home" placement="bottom">
      <Link
        to="/chooser"
        data-testid="home-button"
        aria-label="Home"
        className="inline-flex items-center justify-center w-8 h-8 text-theme-text-tertiary hover:text-theme-text-primary hover:bg-theme-bg-conv-hover rounded-sm transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-focus-ring"
      >
        <Home className="w-4 h-4" strokeWidth={1.5} aria-hidden />
      </Link>
    </Tooltip>
  );
}
